<div class="flex flex-row items-center">
    @if (!scanIsClean) {
        <div class="select-spacer w-[50px]"></div>
    }
    <button [disabled]="!scanIsClean"
            (click)="viewDocument()">
        <span [class]="scanIsClean ? 'text-blue-400' : 'text-lendio-warm-gray-400'">{{ filename }}</span>
    </button>
</div>
